import { render, staticRenderFns } from "./Trucker.vue?vue&type=template&id=ce2c6be2&"
import script from "./Trucker.vue?vue&type=script&lang=js&"
export * from "./Trucker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports